/* eslint-disable no-console */
import { useState, useCallback, useContext } from 'react';
import { GatewayContext, LoggingContextType } from '../context';
import { LogLevel, Log } from '../models';

export default function useLogging(): LoggingContextType {
  const { gatewayUrl, getAuthToken, canUseGatewayApi } = useContext(GatewayContext);
  const [logs, setLogs] = useState<Log[]>([]);

  const flush = useCallback(async () => {
    if (logs.length === 0) {
      return;
    }

    if (!canUseGatewayApi) {
      return;
    }

    logs.map((l) => l.propertyValues?.map(() => []));

    try {
      var result = await fetch(`${gatewayUrl}/api/v1/log`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAuthToken()}`
        },
        mode: 'cors',
        body: JSON.stringify({
          Logs: logs
        })
      });

      if (!result.ok) {
        console.error('Error Sending Logs:', result.statusText);
      }
    } catch (err) {
      // Swallow the error, we don't want logging issues to cause user facing issues
      console.error('Error Sending Logs:', err);
    }

    setLogs([]);
  }, [logs, gatewayUrl, getAuthToken, canUseGatewayApi]);

  function logInfo(messageTemplate: string, propertyValues?: any[]): void {
    if (propertyValues) {
      console.info(messageTemplate, propertyValues);
    } else {
      console.info(messageTemplate);
    }
  }

  function logWarn(messageTemplate: string, propertyValues?: any[]) {
    if (propertyValues) {
      console.warn(messageTemplate, propertyValues);
    } else {
      console.warn(messageTemplate);
    }
  }

  function logError(messageTemplate: string, propertyValues?: any[]) {
    if (propertyValues) {
      console.error(messageTemplate, propertyValues);
    } else {
      console.error(messageTemplate);
    }

    const log = {
      logLevel: LogLevel.Error,
      messageTemplate: messageTemplate.toString(),
      propertyValues: propertyValues,
      userAgent: window.navigator.userAgent,
      timestamp: new Date(),
      version: ''
    };

    // TODO fix later
    // if (UVR_VERSION) {
    //   log.version = UVR_VERSION;
    // }

    setLogs([...logs, log]);
  }

  return {
    logInfo,
    logWarn,
    logError,
    flush
  };
}
